import { gql } from "@apollo/client";

import type { DraftPreviewStyle } from "@/graphql/get-draft-preview";

export const UPDATE_DRAFT_PREVIEW_DESIGN = gql`
  mutation UpdateDraftPreviewDesign(
    $instagramUsername: String!
    $css: String!
    $style: PreviewStyleInput!
  ) {
    updatePreview(
      instagramUsername: $instagramUsername
      css: $css
      style: $style
    ) {
      id
      css
      style {
        buttonRadius
        buttonBorder
        buttonBorderColour
        buttonFontColour
        buttonBackground
        buttonOpacity
        buttonBoxShadowColour
        fontColour
        background
      }
      updatedAt
    }
  }
`;

export interface UpdateDraftPreviewDesignData {
  updatePreview: {
    id: string;
    css: string;
    style: DraftPreviewStyle;
    updatedAt: string;
  };
}

export interface PreviewStyleInput {
  buttonRadius: number;
  buttonBorder: number;
  buttonBorderColour: string;
  buttonFontColour: string;
  buttonBackground: string;
  buttonOpacity: number;
  buttonBoxShadowColour: string;
  fontColour: string;
  background: string;
}

export interface UpdateDraftPreviewDesignVariables {
  instagramUsername: string;
  css: string;
  style: PreviewStyleInput;
}
